import type { CustomIconProps } from '../CustomIcon';

export const RestoreIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => (
  <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M23 20v-6h-6M1 4v6h6'
      stroke={secondaryColor}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20.49 9A9 9 0 005.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 013.51 15'
      stroke={secondaryColor}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle
      cx={12}
      cy={12}
      r={2}
      fill={color}
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
